<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesMstLocalStorageResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      with-custom-row-actions-first-column
                                      custom-row-actions-text-first-column="预览"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                      <template #left-header>
                                        <em-button type="edit" custom-icon="fa fa-file-upload fa-lg fa-arrow-down"                                                    
                                                    custom-label="上传文件"
                                                    v-menu-permission="'edit'"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="uploadFileDialog()"
                                        >
                                        </em-button>
                                      </template>
                                      <template #customRowActionsFirstColumn="{row}">
                                        <b-button-group>
                                            <em-button
                                            type="previewPdfFile"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="previewPdfFile(row)"
                                            ></em-button>                                           
                                        </b-button-group>
                                        </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog
            title="上传文件"
            :center="true"
            width="30%"            
            :visible.sync="uploadDialogVisible">
            <el-form :model="form" size="small" label-width="80px">
                
                <el-form-item label="文件名">
                <el-input v-model="form.name" style="width: 80%;" />
                </el-form-item>
                <!--   上传文件   -->
                <el-form-item label="上传">                    
                    <el-upload
                        ref="upload"               
                        :limit="1"                    
                        :on-change="handleChange"
                        :on-success="handleSuccess"                
                        :auto-upload="false"                   
                        :action="entityBaseUrl+'create?name=' + form.name"      
                        style="width: 80%;"               
                    >
                        <div slot="trigger" class="sith-upload"><i class="el-icon-upload" /> 添加文件</div>
                        <div slot="tip" class="el-upload__tip">可上传文件不超过100M</div>                    
                    </el-upload>                
                </el-form-item>
            </el-form>        
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadFile">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
// Author Eric
// Date 2021-03-19 15:48:40

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesMstLocalStorageListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin],
    props:{
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {                
            uploadDialogVisible:false,
            form:{
                name:''
            }
        }
    },
    computed:{
        modelName(){
            return this.$_emRouterHelperMixin_entityName
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
    },
    methods:{
        previewPdfFile(row) {
            if(row.suffix == "pdf"){
                this.$router.push({name: `previewPdf`,query: {path: row.realName}}); 
            }            
        },
        
        handleChange(file) {            
            var fileName = file.name;
            this.form.name = fileName.substr(0,fileName.lastIndexOf("."));
            if(file.size > 100*1024*1024){
                this.$message.warning({
                    duration: 5000,
                    message: "文件超过100M，请压缩后再上传"
                    });
            }
        },
        handleSuccess(file){                        
            this.$refs.upload.clearFiles();              
        },
        
        uploadFileDialog() {
            this.form.name = null;  
            this.uploadDialogVisible = true;
            
        },
        uploadFile() {                
            this.$refs.upload.submit();  
            this.uploadDialogVisible = false;
            this.$store.commit("sithMesMstLocalStorage/setNeedToRefresh", true);
        }
    }
};
</script>
<style>

.sith-upload{
  text-align: center;
  border: 1px dashed #c0ccda;
  border-radius: 5px;
  height: 45px;
  line-height: 45px; 
    
}
.el-upload{
  width: 100% !important;  
}
</style>